export default{
   checkWeekend() {
    let date = new Date().getTime()
    let day = new Date(date).getDay();
    let isWeekend = true
    if(day == 6 || day == 0){
      isWeekend = false
      return isWeekend
    }
    return isWeekend
  }
}



// WEBPACK FOOTER //
// ./src/plugins/check-weekend.js